import { clamp, isFinite } from 'lodash';

export const calculatePercentage = (partial: number, total: number): number => {
	// check inputs
	if (total === 0 || !isFinite(total) || !isFinite(partial)) {
		return 0;
	}

	const percentage = (partial / total) * 100;

	// clamp the result between 0 and 100
	return clamp(percentage, 0, 100);
};
